export default "__VITE_ASSET__CRDLxAWC__"